import React, { useEffect, useState } from "react";
import "./ImageGen.css";
import ImageSlider from "./ImageSlider";
import Loader from "./Loader";

const fetchVoices = (inputText) => {
  const availableVoices = speechSynthesis.getVoices();

  const ziraVoice = availableVoices.find(
    (voice) => voice.name === "Google हिन्दी"
  );

  const utterance = new SpeechSynthesisUtterance(inputText);
  utterance.voice = ziraVoice;
  utterance.rate = 1.2; // Speech rate (0.1 to 10)
  utterance.pitch = 1; // Speech pitch (0 to 2)

  return speechSynthesis.speak(utterance);
};

const ImageGen = () => {
  const [prompt, setPrompt] = useState("");
  const [hasImage, setImageState] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [isLoading, setLoading] = useState(true);

  const handleInputPrompt = (event) => {
    setPrompt(event.target.value);
  };

  const handleRandomPrompt = () => {
    let randomPrompts = [
      "Generate a colorful abstract painting",
      "Create a serene landscape with mountains and a peaceful lake",
      "Design a futuristic cityscape at dusk with glowing neon lights",
      "Generate a vibrant floral arrangement with a mix of roses, tulips, and daisies",
      "Create a mystical underwater scene with tropical fish and coral reefs",
      "Design an otherworldly alien planet with strange plants and creatures",
      "Generate a whimsical fantasy illustration with fairies and unicorns",
      "Create a dynamic sports action scene with athletes in motion",
      "Design an elegant logo for a high-end fashion brand",
      "Generate a retro-style poster for a music concert",
      "Create a surreal landscape merging elements of the desert and the ocean",
      "Generate a mosaic pattern using vibrant geometric shapes",
      "Design a futuristic vehicle concept that combines elements of cars and spaceships",
      "Create a digital portrait of a famous historical figure using a modern artistic style",
      "Generate a dreamy and ethereal scene with floating islands and a rainbow sky",
      "Design a book cover for a thrilling mystery novel set in a haunted mansion",
      "Create a minimalist illustration of a city skyline at night",
      "Generate a dynamic and energetic abstract composition using bold brushstrokes",
      "Design a logo for a sustainable eco-friendly brand with elements of nature",
      "Create a vintage-inspired movie poster for a science fiction film",
      "A neon cityscape at sunset",
      "A surreal underwater world with floating islands",
      "A futuristic cyberpunk metropolis",
      "An enchanted forest with glowing flora",
      "A celestial dance of stars and galaxies",
      "A steampunk-inspired airship soaring through the clouds",
      "A magical portal to another dimension",
      "A mesmerizing cosmic explosion of colors",
      "A tranquil mountain landscape reflected in a crystal-clear lake",
      "A vibrant and abstract geometric pattern",
      "A young girl with a book, lost in a world of imagination",
      "A group of girls forming a band and rocking the stage",
      "A girl with a paintbrush, creating vibrant artwork",
      "A girl dancing gracefully, expressing her passion for ballet",
      "A girl exploring nature and discovering hidden treasures",
      "A girl wearing a superhero cape, ready to save the day",
      "A girl embracing her inner scientist, conducting exciting experiments",
      "A girl confidently leading a team, inspiring others with her leadership",
      "A girl playing a musical instrument, captivating the audience with her talent",
      "A girl in a sports arena, displaying strength and determination in her favorite sport",
      "An intense soccer match in a packed stadium",
      "A basketball player executing a perfect slam dunk",
      "A swimmer slicing through the water with incredible speed",
      "A cyclist conquering a challenging mountain climb",
      "A tennis player serving an ace with precision",
      "A gymnast performing a gravity-defying routine on the balance beam",
      "A surfer catching a massive wave and riding it with skill",
      "A boxer delivering a powerful knockout punch",
      "A track and field athlete soaring over the high jump bar",
      "A baseball player hitting a home run, sending the ball soaring into the sky"
    ];

    let prompt =
      randomPrompts[Math.floor(Math.random() * randomPrompts.length)];
    setPrompt(prompt);
  };

  const handleSubmit = async () => {
    setLoading(true);
    setImageState(true);
    const response = await fetch("https://shremish-backend11.onrender.com/image-gen", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ prompt }),
    });

    const json = await response.json();

    if (json) {
      setLoading(false);
    }

    setImageUrl(json);
  };

  useEffect(()=>{
    fetchVoices("Welcome to the Realm of Image Creation!");
  },[])

  return (
    <>
      <div className="image-gen-container">
        <div className="surprise-container">
          <p className="head">Shremish</p>
          <p className="head-desc">Image Generating Tool (Powered By AI)</p>
        </div>

        <div className="surprise-button">
          <button onClick={handleRandomPrompt}>Feeling Lucky?</button>
        </div>

        <div className="input-class">
          <input
            type="text"
            placeholder="Enter your prompt"
            value={prompt}
            onChange={handleInputPrompt}
          ></input>
          <div className="generate-button" onClick={handleSubmit}>
            <p>Generate</p>
          </div>
        </div>

        {hasImage ? (
          <div className="output-image">
            {isLoading ? (
              <Loader />
            ) : (
              <img
                style={{
                  margin: "auto",
                  display: "block",
                  borderRadius: "10px",
                  marginTop: "2rem",
                  marginBottom: "1rem",
                }}
                src={imageUrl}
                alt="Image"
              />
            )}
          </div>
        ) : (
          <ImageSlider />
        )}
      </div>
    </>
  );
};

export default ImageGen;
